import React from "react";
import {
  Tooltip as Base,
  TooltipContent,
  TooltipPortal,
  TooltipTrigger,
} from "./ui/tooltip";

const Tooltip = ({ className, children, value, delayDuration = 300 }) =>
  value?.length > 0 ? (
    <Base delayDuration={delayDuration}>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipPortal>
        <TooltipContent className={className}>{value}</TooltipContent>
      </TooltipPortal>
    </Base>
  ) : (
    children
  );

export default Tooltip;
